<!--
  ~ Copyright (c) 2019 Signum+ Software & Facility GmbH
  ~ Author: jahn@signum-plus.at
  -->

<ng-container *ngIf="labelModel" [kitComponent]="labelModel" kitComponentClass="kit-form-field-label"></ng-container>
<div class="kit-form-field-value">
  <ng-container [kitComponent]="model.control" kitComponentClass="kit-form-field-control">
  </ng-container>
  <div [kitValueError]="model.control" class="kit-form-field-error"></div>
</div>